/* eslint-disable ember/no-classic-components */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class TemplateCard extends Component {
  template = null;
  onClick = null;
  onDelete = null;
  isCreate = false;
  createLabel = '';

  // Stop the click from bubbling to the card's own onClick (which opens the
  // template) before invoking the delete handler.
  @action
  handleDelete(event) {
    if (event) {
      event.stopPropagation();
    }
    if (this.onDelete) {
      this.onDelete(this.template);
    }
  }
}
